
export const addSectionAction = function (item) {
    return {
        type: "FB_ADD_SECTION",
        payload: item
    }
};

export const setSectionsAction = function (items) {
    return {
        type: "FB_SET_SECTIONS",
        payload: items
    }
};

export const removeSectionAction = function (item) {
    return {
        type: "FB_REMOVE_SECTION",
        payload: item
    }
};

export const clearSectionsAction = function () {
    return {
        type: "FB_CLEAR_SECTIONS"
    }
};


export const changeSectionAction = function (item) {
    return {
        type: "FB_CHANGE_SECTION",
        payload: item
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/sections.js